


import {MapboxSearchBox} from '@mapbox/search-js-web';


export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use( () => {return new MapboxSearchBox()});
  });